import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'ig-drop-down-trigger',
    templateUrl: './drop.down.trigger.component.html',
    styleUrls: ['./drop.down.trigger.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DropDownTriggerComponent {
    @Input() public icon = 'keyboard_arrow_down';
    @Input() public useDiv = false;
    @Input() public useIcon = true;
    @Input() public text = '';
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/drop.down/trigger/drop.down.trigger.component.ts